import React, { useState, useEffect, useRef, useContext } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Card, Container, Modal, Form, Button } from "react-bootstrap";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { IoIosClock } from "react-icons/io";
import { IoDocumentTextSharp } from "react-icons/io5";
import One from "../../../assets/colorgameImage/one.png";
import { FaFilter } from "react-icons/fa";
import Two from "../../../assets/colorgameImage/two.png";
import Three from "../../../assets/colorgameImage/three.png";
import Four from "../../../assets/colorgameImage/four.png";
import Five from "../../../assets/colorgameImage/five.png";
import Six from "../../../assets/colorgameImage/six.png";
import Seven from "../../../assets/colorgameImage/seven.png";
import Eight from "../../../assets/colorgameImage/eight.png";
import Nine from "../../../assets/colorgameImage/nine.png";
import Zero from "../../../assets/colorgameImage/zero.png";
import Countdown from "../../../assets/colorgameImage/Audio/countdowntune.mp3";
import axios from "axios";
import Swal from "sweetalert2";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";
import { MdOutlineSupportAgent } from "react-icons/md";
import { SiNeteasecloudmusic } from "react-icons/si";


// import { useCredit } from "./CreditContext";
// import { ResultContext } from "./ResultContext";
// import { useAppContext } from "./AppContext";
import { FaIndianRupeeSign } from "react-icons/fa6";
import WingoChart from "./WingoChart";
import WingoHeader from "./WingoHeader";
import { fetchWithAuth, logoutUser } from "./authApi";
import logo from "../../../assets/img/logo.png";
import { decryptData, encryptData } from "../../../decryptHelper";

export default function ColorIndex(data) {
  const [activeButtons, setActiveButtons] = useState(null);
  const [disbleButtons, setdisbleButtons] = useState(false);
  const [countdownAudio, setCountdownAudio] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const user_id = localStorage.getItem("user_id");
  const [userBetData, setUserBetData] = useState(null);
  const { updateCredit } = 10;
  const [isAgreed, setIsAgreed] = useState(true);
  const [isBetPlacedSuccessfully, setIsBetPlacedSuccessfully] = useState(true);
  const isLoading = useRef(false);
  const [loading, setLoading] = useState(false);
  const [remainingSec, setRemainingSec] = useState(0);
  const [periodId, setPeriodId] = useState("");
  const [scopeValues, setScopeValues] = useState([]);
  const [betMultipleValues, setBetMultipleValues] = useState([]);

  const [selectedInterval, setSelectedInterval] = useState(() => {
    return localStorage.getItem("selectedInterval") || null;
  });
  const [selectedColor, setSelectedColor] = useState("");
  const [selectedName, setSelectedName] = useState("");
  const [selectedNumber, setSelectedNumber] = useState("");
  const startTimeRef = useRef(
    Math.floor(new Date(data.startTime).getTime() / 1000),
  );
  const endTimeRef = useRef(
    Math.floor(new Date(data.endTime).getTime() / 1000),
  );
  const location = useLocation();
  const [winAmount, setWinAmount] = useState(0);
  const [lossAmount, setLossAmount] = useState(0);
  const [showLoss, setShowLoss] = useState(false);
  const [showWin, setShowWin] = useState(false);
  const queryParams = new URLSearchParams(location.search);

  const navigate = useNavigate();

  const category_slug = localStorage.getItem("category_slug");
  const subcategory_slug = localStorage.getItem("sub_category_slug");
  const cat_slug = localStorage.getItem("category_slug");
  const sub_cat_slug = localStorage.getItem("sub_category_slug");
  const color = localStorage.getItem("color");
  const name = localStorage.getItem("bigsmallname");
  const category_name = localStorage.getItem("category_name");
  const subcategory_name = localStorage.getItem("sub_category_name");
  const supersubcategory_name = localStorage.getItem("sub_category_name");
  const supersubcategory_slug = localStorage.getItem("sub_category_slug");

  const intervalM = localStorage.getItem("selectedInterval");
  const number = localStorage.getItem("number");
  const big_small = localStorage.getItem("Bigsmall");
  const amount = localStorage.getItem("totalAmount");
  const point = localStorage.getItem("points");

  const [selectedTypeID, setSelectedTypeID] = useState(() => {
    return localStorage.getItem("typeID") || null;
  });
  const [popupRemainingSec, setPopupRemainingSec] = useState(3);

  const [balance, setBalance] = useState(5);
  const [quantity, setQuantity] = useState(1);
  const [activeBalanceButton, setActiveBalanceButton] = useState([]);
  const [activeMultiplierButton, setActiveMultiplierButton] = useState(1);
  const [showFiveSecondsLeft, setShowFiveSecondsLeft] = useState(false);
  const [users, setUsers] = useState([]);
  const [userListData, setUserListData] = useState(null);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);

  const isIndianTimeZone = () => {
    const offset = new Date().getTimezoneOffset();
    const timezoneHours = -offset / 60;
    return timezoneHours === 5.5;
  };

  const itemsPerPage = 7;
  const [messageToHeader, setMessageToHeader] = useState("");

  const sendMessageToHeader = () => {
    setMessageToHeader("Hello from Wingo (parent)!");
  };

  const loaduser1 = async () => {
    const token = localStorage.getItem("tokenl");
    const user_id = localStorage.getItem("userid");
    const dev_id = localStorage.getItem("dev_id");
    let url = `${process.env.REACT_APP_API_URL_COLOR_GAME_NODE}user-profile`;
    const requestData = {
      app_id: process.env.REACT_APP_API_ID,
      user_id: user_id,
      dev_id: dev_id,
    };
    // alert(user_id);
    const encryptedText = encryptData(requestData);
    const datasend = { data: encryptedText };

    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      // body: JSON.stringify(requestData),
      body: JSON.stringify(datasend),
    };

    try {
      const response = await fetch(url, config);
      const data1 = await response.json();
      const data = decryptData(data1.encryptedResponse);
      if (data.data.success == 3) {
        localStorage.removeItem("userid");
        localStorage.removeItem("tokenl");
        localStorage.removeItem("dev_id");
        window.location.href = "/";
      }
      if (token != data.data.tokenl) {
        localStorage.removeItem("userid");
        localStorage.removeItem("tokenl");
        localStorage.removeItem("dev_id");
        window.location.href = "/";
      }

      if (data.data.user_status == 0) {
        localStorage.removeItem("userid");
        localStorage.removeItem("tokenl");
        localStorage.removeItem("dev_id");
        window.location.href = "/";
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  useEffect(() => {
    loaduser1();
  }, []);

  // -----------------------game super sub category ---------------------------------------------
  const fetchSuperCat = async () => {
    try {
      isLoading.current = true;
      setLoading(true);

      // const response = await fetchWithAuth(
      //   `${process.env.REACT_APP_API_URL_COLOR_GAME_NODE}game-super-sub-category`,
      //   {
      //     method: "POST",
      //     headers: {
      //       "Content-Type": "application/json",
      //     },
      //     body: JSON.stringify({
      //       cat_slug: cat_slug,
      //       sub_cat_slug: sub_cat_slug,
      //     }),
      //   },
      // );
      const url = `${process.env.REACT_APP_API_URL_COLOR_GAME_NODE}game-super-sub-category`;
      setLoading(true);
      const config = {
        method: "POST",
        url: url,
        headers: {
          "Content-Type": "application/json",
        },
        data: { cat_slug: "color-game", sub_cat_slug: "color-predaction" },
      };
      const responseData = await axios(config);
      const responseData1 = responseData.data.data;
      console.warn(responseData1);
      setUserBetData(responseData1);
      if (responseData1.length > 0) {
        // alert("sssss");
        const firstItem = responseData1[0];
        const scopeString = firstItem.scope;
        const betMultipleString = firstItem.betMultiple;
        const typeName = firstItem.typeName;
        const slug = firstItem.slug;
        const intervalM = firstItem.intervalM;
        const typeIds = firstItem.typeID;

        const scopes = scopeString.split("|").map(Number);
        const betMultiples = betMultipleString.split("|").map(Number);

        localStorage.setItem("super_sub_cat_name", typeName);
        localStorage.setItem("super_sub_cat_slug", slug);
        localStorage.setItem("intervalM", intervalM);
        localStorage.setItem("typeID", typeIds);
        setScopeValues(scopes);
        setBetMultipleValues(betMultiples);
      }

      isLoading.current = false;
      setLoading(false);
    } catch (error) {
      isLoading.current = false;
      console.error("Error fetching user data:", error);
      setLoading(false);
    }
  };

  // ============================================================
  // 🔥 HELPER FUNCTIONS - FIXED
  // ============================================================

  const getIntervalInSeconds = (interval) => {
    if (!interval) return 0;
    const intervalStr = interval.toString();

    // 🔥 FIX: Exact seconds for each interval
    if (intervalStr === "0.30") return 30;
    else if (intervalStr === "1") return 60;
    else if (intervalStr === "3") return 180;
    else if (intervalStr === "5") return 300;
    else {
      const num = parseFloat(intervalStr);
      return Math.round(num * 60);
    }
  };

  const formatTime = (seconds) => {
    const safeSeconds = Math.max(0, Math.floor(seconds));
    const mins = Math.floor(safeSeconds / 60);
    const secs = safeSeconds % 60;
    return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  useEffect(() => {
    const audio = new Audio(Countdown);
    audio.preload = "auto";
    setCountdownAudio(audio);

    return () => {
      if (audio) {
        audio.pause();
        audio.src = "";
      }
    };
  }, []);

  useEffect(() => {
    // alert("opopop");
    if (!isLoading.current) {
      if (intervalM) {
        fetchData(intervalM);
      }
      fetchSuperCat();
      fetchResults(intervalM);
      fetchColorList(intervalM);
    }
  }, [intervalM, category_slug, subcategory_slug]);

  useEffect(() => {
    fetchData();
  }, []);

  // ============================================================
  // 🔥 MAIN TIMER - FIXED
  // ============================================================
  useEffect(() => {
    let timer = null;

    if (selectedInterval) {
      timer = setInterval(() => {
        const currentInterval = selectedInterval;

        let storedStartTime = parseInt(
          localStorage.getItem(`startTime_${currentInterval}`),
          10,
        );

        if (!storedStartTime || isNaN(storedStartTime)) {
          fetchData(currentInterval);
          return;
        }

        const intervalSec = getIntervalInSeconds(currentInterval);
        const currentTime = Math.floor(Date.now() / 1000);
        const elapsed = currentTime - storedStartTime;
        let remainingTime = Math.max(0, intervalSec - elapsed);

        setRemainingSec(remainingTime);

        if (remainingTime === 5 && remainingTime > 0) {
          playCountdownSound();
          setShowFiveSecondsLeft(true);
          setPopupRemainingSec(5);
          setShowPopup(true);
          setIsopen(false);
          setdisbleButtons(true);
        } else if (remainingTime > 7) {
          setShowPopup(false);
          setShowFiveSecondsLeft(false);
        }

        if (remainingTime <= 0) {
          setShowPopup(false);
          setShowFiveSecondsLeft(false);
          setdisbleButtons(false);

          fetchcolorlistAndCompareResults(currentInterval);
          fetchColorList(currentInterval);
          if (!isLoading.current) {
            fetchResults(currentInterval);
          }

          localStorage.removeItem(`startTime_${currentInterval}`);
          fetchData(currentInterval);
        }
      }, 1000);
    }

    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [selectedInterval]);

  // ============================================================
  // 🔥 FETCH DATA - FIXED
  // ============================================================
  const fetchData = async (intervalM) => {
    const intervalM1 = intervalM === null ? "0.30" : intervalM;
    try {
      // alert(intervalM);
      isLoading.current = true;
      const url = `${process.env.REACT_APP_API_URL_COLOR_GAME_NODE}color-Game-Issue`;
      setLoading(true);
      const config = {
        method: "POST",
        url: url,
        headers: {
          "Content-Type": "application/json",
        },
        data: { intervalM: intervalM1 },
      };
      const response = await axios(config);
      setUsers(response.data.data);
      const { issueNumber, startTime, endTime, remainingTime } =
        response.data.data;
      setPeriodId(issueNumber);

      const startTimestamp = Math.floor(new Date(startTime).getTime() / 1000);
      localStorage.setItem(`startTime_${intervalM1}`, startTimestamp);

      const currentTime = Math.floor(Date.now() / 1000);
      const intervalSec = getIntervalInSeconds(intervalM1);
      let calculatedRemaining = Math.max(
        0,
        startTimestamp + intervalSec - currentTime,
      );

      setRemainingSec(calculatedRemaining);

      fetchData123();
      isLoading.current = false;
    } catch (error) {
      isLoading.current = false;
      console.error("Error fetching user data:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchData123 = async () => {
    try {
      const url = `${process.env.REACT_APP_API_URL_COLOR_GAME_NODE}color-Game-Play-Check`;
      setLoading(true);
      const config = {
        method: "POST",
        url: url,
        headers: {
          "Content-Type": "application/json",
        },
      };
      const response = await axios(config);
      const serverTime = response.data.data.currentTime;
      const clientTime = new Date();
      const clientHHmm = `${String(clientTime.getHours()).padStart(2, "0")}${String(clientTime.getMinutes()).padStart(2, "0")}`;

      if (serverTime !== clientHHmm) {
        await Swal.fire({
          title: "<strong>समय क्षेत्र त्रुटि</strong>",
          html: `
        <div style="text-align:center;">
          <p>आपका सिस्टम समय भारतीय समय क्षेत्र (UTC+05:30) से मेल नहीं खा रहा है</p>
          <p>कृपया अपने डिवाइस का समय और समय क्षेत्र सेटिंग जांचें:</p>
          <ol style="text-align:left;list-style:decimal">
            <li>सही समय क्षेत्र (IST/भारत) चुनें</li>
            <li>इंटरनेट समय सिंक्रोनाइज़ेशन चालू करें</li>
            <li>समय स्वचालित रूप से सेट करें विकल्प सक्षम करें</li>
          </ol>
        </div>
        `,
          icon: "error",
          confirmButtonText: "समझ गया / Understood",
          confirmButtonColor: "#000",
          footer:
            "गेम तभी खेल सकते हैं जब समय सही हो / Game can only be played with correct time settings",
          customClass: {
            title: "text-dark",
            content: "text-dark",
            confirmButton: "confirmbutton",
            cancelButton: "cancelbutton",
          },
        });
        navigate("/home");
        return;
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const playCountdownSound = () => {
    if (countdownAudio) {
      countdownAudio.play().catch((error) => {
        console.log("Audio play failed:", error);
      });
    }
  };

  // Popup countdown
  useEffect(() => {
    if (showPopup) {
      const popupTimer = setInterval(() => {
        setPopupRemainingSec((prevPopupSec) => {
          if (prevPopupSec > 1) {
            return prevPopupSec - 1;
          } else {
            clearInterval(popupTimer);
            setShowPopup(false);
            return 0;
          }
        });
      }, 1000);

      return () => clearInterval(popupTimer);
    }
  }, [showPopup]);

  useEffect(() => {
    if (userBetData && userBetData.length > 0) {
      if (!selectedInterval) {
        const intervalM = userBetData[0].intervalM;
        const typeID = userBetData[0].typeID;
        setSelectedInterval(intervalM);
        localStorage.setItem("selectedInterval", intervalM);
        setSelectedTypeID(typeID);
        localStorage.setItem("typeID", typeID);
      }
      startTimeRef.current = Math.floor(Date.now() / 1000);
    }
  }, [userBetData, selectedInterval]);

  useEffect(() => {
    if (selectedTypeID) {
      // fetchRuleData(selectedTypeID);
    }
  }, [selectedTypeID]);

  // ============================================================
  // 🔥 TAB SWITCH
  // ============================================================
  const handleTabClick = (intervalM, typeID) => {
    if (selectedInterval === intervalM) return;

    localStorage.setItem("selectedInterval", intervalM);
    localStorage.setItem("intervalM", intervalM);
    localStorage.setItem("typeID", typeID);
    setSelectedInterval(intervalM);
    setSelectedTypeID(typeID);

    setShowPopup(false);
    setShowFiveSecondsLeft(false);
    setdisbleButtons(false);

    fetchData(intervalM);
    fetchResults(intervalM);
    fetchColorList(intervalM);
  };
  useEffect(() => {
    loaduser();
  }, []);
  const loaduser = async () => {
    const dev_id = localStorage.getItem("dev_id");
    const user_id = localStorage.getItem("userid");
    let url = `${process.env.REACT_APP_API_URL_COLOR_GAME_NODE}home`;

    const requestData = {
      app_id: process.env.REACT_APP_API_ID,
      user_id: user_id,
      dev_id: dev_id,
    };
    const encryptedText = encryptData(requestData);
    const datasend = { data: encryptedText };

    var config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(datasend),
    };

    try {
      const response = await fetch(url, config);
      const response1 = await response.json();
      const data1 = decryptData(response1.encryptedResponse);
      const data = data1.data.rows;
      if (data.colorGameONOFF == "0") {
        navigate("/home");
        return;
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };
  // -----------------------game super sub category ---------------------------------------------

  const [lastButtonClicked, setLastButtonClicked] = useState(null);
  const [clicked, setClicked] = useState(false);

  const handleSaveTotalAmount = async () => {
    loaduser1();
    if (!isIndianTimeZone()) {
      alert(
        "This application is only available in Indian timezone (UTC+05:30).",
      );
      localStorage.clear();
      window.location.reload();
      window.location.href = "/";
      return;
    }
    if (remainingSec <= 7) {
      Swal.fire({
        title: "Error!",
        text: "Please wait for next period.",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    if (!isAgreed) {
      Swal.fire({
        title: "Error!",
        text: "Please agree to the pre-sales rule.",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }
    if (totalAmount < 5) {
      Swal.fire({
        title: "Error!",
        text: "Minimun bet amount is 5 Rs.",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    if (totalAmount > 20000) {
      Swal.fire({
        title: "Error!",
        text: "Maximum bet amount is 20,000 Rs.",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    localStorage.setItem("amount", totalAmount);

    try {
      isLoading.current = true;
      setLoading(true);
      const user_id = localStorage.getItem("userid");
      const requestData = {
        user_id,
        category_slug,
        category_name,
        subcategory_slug,
        subcategory_name,
        supersubcategory_name,
        supersubcategory_slug,
        game_type_time: selectedInterval,
        period_id: periodId ? periodId.toString() : "",
        quantity: quantity ? quantity.toString() : "",
        amount: totalAmount.toString(),
        point: totalAmount ? totalAmount.toString() : "",
      };
      if (lastButtonClicked === "color" && color) {
        requestData.color = color.toString();
      } else if (lastButtonClicked === "number" && number) {
        if (numberColor === "linear-gradient(to right, violet, #fd565c)") {
          requestData.number = number.toString();
        } else if (
          numberColor === "linear-gradient(to right, #40ad72, violet)"
        ) {
          requestData.color = "green violet";
          requestData.number = number.toString();
        } else {
          requestData.number = number.toString();
          requestData.color = getColorName("number", number);
        }
      } else if (lastButtonClicked === "big_small" && big_small) {
        requestData.big_small = big_small.toString();
        requestData.color = getColorName("big_small", big_small);
      } else {
        Swal.fire({
          title: "Error!",
          text: "Please select color, number, or big/small.",
          icon: "error",
          confirmButtonText: "OK",
        });
        setLoading(false);
        return;
      }

      const config = {
        method: "POST",
        url: `${process.env.REACT_APP_API_URL_COLOR_GAME_NODE}color-bet-place`,
        headers: {
          "Content-Type": "application/json",
        },
        data: requestData,
      };

      const response = await axios(config);

      const responseData = response.data;
      console.warn("responseData", responseData.success);
      // alert(responseData.success == 1);
      // if (!response.ok) {
      //   throw new Error(responseData.message || "Failed to place bet");
      // }

      if (responseData.success == 1) {
        Swal.fire({
          title: "Success!",
          text: responseData.message,
          icon: "success",
          timer: 1000,
          confirmButtonText: "OK",
          background: "linear-gradient(0deg, #f8ac60 20.19%, #fa7638 100%)",
        });
        setIsBetPlacedSuccessfully(true);
        setIsopen(false);
        setClicked(false);
        await fetchUpdatedCredit();
        await fetchcolorlistAndCompareResults(selectedInterval);
        await fetchColorList(selectedInterval);
      } else if (responseData.success === "0") {
        Swal.fire({
          title: "Error!",
          text: responseData.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      } else {
        Swal.fire({
          title: "Error!",
          text: "Something went wrong. Please try again later.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Error placing bet:", error);
      Swal.fire({
        title: "Error!",
        text: error.message || "Failed to place bet",
        icon: "error",
        confirmButtonText: "OK",
      });

      if (error.response?.status === 401) {
        logoutUser();
      }
    } finally {
      isLoading.current = false;
      setLoading(false);
      setIsBetPlacedSuccessfully(false);
    }
  };

  // ------------------------------RESULT API-------------------------------------------------
  const [results, setResults] = useState([]);
  const [colorList, setColorList] = useState([]);
  const [resultsData, setResultsData] = useState([]);

  const newcolor = resultsData?.[0]?.color;

  const fetchResults = async (intervalM) => {
    try {
      isLoading.current = true;
      setLoading(true);
      const url = `${process.env.REACT_APP_API_URL_COLOR_GAME_NODE}one-min-result`;

      const config = {
        method: "POST",
        url: url,
        headers: {
          "Content-Type": "application/json",
        },
        data: { gametype: intervalM, page: currentPage, perpage: itemsPerPage },
      };

      const response = await axios(config);
      const responseData = response.data.data;

      setResults(responseData);
      setTotalPages(response.data.totalPages);
      isLoading.current = false;
      setLoading(false);
    } catch (error) {
      console.error("Error fetching results:", error);
      isLoading.current = false;
      setLoading(false);
    }
  };

  const fetchColorList = async (selectedInterval) => {
    try {
      isLoading.current = true;
      setLoading(true);
      const user_id = localStorage.getItem("userid");
      const config = {
        method: "POST",
        url: `${process.env.REACT_APP_API_URL_COLOR_GAME_NODE}color-bet-list`,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          category_slug: category_slug,
          subcategory_slug: subcategory_slug,
          type: selectedInterval,
          user_id: user_id,
        },
      };

      const response = await axios(config);

      const responseData = response.data;
      const colorData = responseData.data || responseData || [];

      if (colorData.success === "0") {
        setColorList([]);
      } else {
        setColorList(colorData);
      }
    } catch (error) {
      console.error("Error fetching results:", error);
    } finally {
      isLoading.current = false;
      setLoading(false);
    }
  };

  // --------------------------------Result & color-bet-list--------------------------------------
  const isPeriodShown = (periodId) => {
    const stored = JSON.parse(localStorage.getItem("shownPeriods") || "[]");
    return stored.includes(periodId);
  };

  const markPeriodShown = (periodId) => {
    const stored = JSON.parse(localStorage.getItem("shownPeriods") || "[]");
    stored.push(periodId);
    localStorage.setItem("shownPeriods", JSON.stringify(stored));
  };

  const fetchcolorlistAndCompareResults = async (intervalM) => {
    try {
      // const colorListResponse = await fetchWithAuth(
      //   `${process.env.REACT_APP_API_URL_COLOR_GAME_NODE}color-bet-list`,
      //   {
      //     method: "POST",
      //     headers: {
      //       "Content-Type": "application/json",
      //     },
      //     body: JSON.stringify({
      //       category_slug: category_slug,
      //       subcategory_slug: subcategory_slug,
      //       type: intervalM,
      //     }),
      //   },
      // );
      const user_id = localStorage.getItem("userid");
      const urls = `${process.env.REACT_APP_API_URL_COLOR_GAME_NODE}color-bet-list`;

      const configs = {
        method: "POST",
        url: urls,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          gametype: intervalM,
          page: currentPage,
          perpage: itemsPerPage,
          user_id: user_id,
        },
      };

      // const colorListData123 = await colorListResponse.json();
      // const colorListData = colorListData123.data;
      const resultResponses = await axios(configs);
      const colorListData = resultResponses.data.data;
      // console.warn("colorListData", colorListData);
      if (!colorListData || colorListData.length === 0) {
        setLoading(false);
        isLoading.current = false;
        return;
      }

      const colorPeriodId = colorListData[0].period_id;

      sendMessageToHeader();

      setTimeout(() => {
        setMessageToHeader("");
      }, 500);

      const filteredData = colorListData.filter(
        (item) => item.period_id === colorPeriodId && item.result === "win",
      );

      const lossData = colorListData.filter(
        (item) => item.period_id === colorPeriodId && item.result !== "win",
      );

      const totalWinAmount = filteredData.reduce((sum, item) => {
        return sum + (parseFloat(item.win_amount) || 0);
      }, 0);

      const totalLossAmount = lossData.reduce((sum, item) => {
        return sum + (parseFloat(item.amount) || 0);
      }, 0);

      setWinAmount(totalWinAmount);
      setLossAmount(totalLossAmount);

      const resultDataShow =
        filteredData.length > 0 ? filteredData[0].result : "loss";

      const url = `${process.env.REACT_APP_API_URL_COLOR_GAME_NODE}one-min-result`;

      const config = {
        method: "POST",
        url: url,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          gametype: intervalM,
          page: currentPage,
          perpage: itemsPerPage,
        },
      };

      const resultResponse = await axios(config);
      const resultData = resultResponse.data.data;
      // console.warn("resultData", resultData);
      if (resultData && resultData.length > 0) {
        const resultPeriodId = resultData[0].periodid;

        if (isPeriodShown(resultPeriodId)) {
          setLoading(false);
          isLoading.current = false;
          return;
        }

        markPeriodShown(resultPeriodId);
        // alert(resultDataShow);
        if (colorPeriodId === resultPeriodId) {
          setResultsData([resultData[0]]);

          if (resultDataShow === "win") {
            setShowWin(true);
            setShowLoss(false);
            setWinpopup(true);
            setLosspopup(false);
          } else {
            setShowLoss(true);
            setShowWin(false);
            setLosspopup(true);
            setWinpopup(false);
          }
        } else {
          setShowWin(false);
          setShowLoss(false);
          setWinpopup(false);
          setLosspopup(false);
        }
      }

      setLoading(false);
      isLoading.current = false;
    } catch (error) {
      console.error("Error fetching and comparing results:", error);
      setLoading(false);
      isLoading.current = false;
    }
  };

  //----------- this is credit amout API for refreshing the credit amount-----------------
  const fetchUpdatedCredit = async () => {
    try {
      const response = await fetchWithAuth(
        `${process.env.REACT_APP_API_URL_COLOR_GAME_NODE}profile-list`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ user_status: "1" }),
        },
      );

      const responseData1 = await response.json();
      const responseData = responseData1.data;

      if (responseData) {
        const newCredit = responseData.credit;
        updateCredit(newCredit);
        sendMessageToHeader();
        setTimeout(() => {
          setMessageToHeader("");
        }, 500);
      }
    } catch (error) {
      console.error("Error fetching updated credit:", error);
    }
  };

  const [ruleData, setRuleData] = useState(null);

  // const fetchRuleData = async (typeID) => {
  //   try {
  //     setLoading(true);
  //     const url = `${process.env.REACT_APP_API_URL_COLOR_GAME_NODE}color-Game-RuleByTypeId`;
  //     const config = {
  //       method: "POST",
  //       url: url,
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       data: JSON.stringify({
  //         typeID: typeID,
  //       }),
  //     };
  //     const response = await axios(config);
  //     setRuleData(response.data.data[0]);
  //     setLoading(false);
  //   } catch (error) {
  //     console.error(
  //       "Error fetching rule data:",
  //       error.response ? error.response.data : error.message,
  //     );
  //     setLoading(false);
  //   }
  // };

  const toggleClass = (buttonId) => {
    setActiveButtons(buttonId === activeButtons ? null : buttonId);
  };

  const [showmodel, setShowmodel] = useState(false);
  const handlemodelclose = () => setShowmodel(false);
  const handleShowmodel = () => setShowmodel(true);
  const [activebtn, setActivebtn] = useState(null);
  const toggleClassamt = (buttonId, value) => {
    setActivebtn(buttonId === activebtn ? null : buttonId);
    setActiveBalanceButton(value);
  };

  const [show, setShow] = useState(false);
  const [placement, setPlacement] = useState("");
  const [numberColor, setNumberColor] = useState();
  const [bsmall, setBsmall] = useState("");

  const handleMultiplierButtonClick = (mult) => {
    setQuantity(mult);
    setActiveMultiplierButton(mult);
  };

  const handleBalanceButtonClick = (value) => {
    setBalance(value);
    setActiveBalanceButton(value || value * value);
    setActiveMultiplierButton(null);
    localStorage.setItem("point", value);
    localStorage.setItem("Quantity", 1);
  };

  const increment = () => {
    setQuantity((prevQuantity) => prevQuantity + 1);
    localStorage.setItem("Quantity", quantity + 1);
  };

  const decrement = () => {
    if (quantity > 1) {
      setQuantity((prevQuantity) => prevQuantity - 1);
      localStorage.setItem("Quantity", quantity - 1);
    }
  };

  const totalAmount = balance * quantity;
  const handleClose = () => setShow(false);
  const handleShow = (placement) => {
    setShow(true);
    setPlacement(placement);
    setBsmall(bsmall);
  };

  const bigsmall = [
    { name: "Big", color: "#dd9139" },
    { name: "Small", color: "#5088d3" },
  ];

  const [isopen, setIsopen] = useState(false);

  const resetValues = () => {
    setActiveBalanceButton(null);
    setQuantity(1);
    setActiveMultiplierButton(null);
  };

  const Togglepopup = () => {
    setClicked(false);
    setIsopen(!isopen);
    if (!isopen) {
      resetValues();
    }
  };

  const Toggleoff = () => {
    setIsopen(!isopen);
  };

  const selectColors = [
    { name: "Green", color: "green" },
    { name: "Violet", color: "violet" },
    { name: "Red", color: "red" },
  ];

  const balls = [
    {
      number: "0",
      colorName: "red violet",
      color: "linear-gradient(to right, violet, #fd565c)",
      image: Zero,
    },
    { number: "1", color: "green", image: One },
    { number: "2", color: "red", image: Two },
    { number: "3", color: "green", image: Three },
    { number: "4", color: "red", image: Four },
    {
      number: "5",
      colorName: "green violet",
      color: "linear-gradient(to right, #40ad72, violet)",
      image: Five,
    },
    { number: "6", color: "red", image: Six },
    { number: "7", color: "green", image: Seven },
    { number: "8", color: "red", image: Eight },
    { number: "9", color: "green", image: Nine },
  ];

  const getColorName = (selectedType, value) => {
    if (selectedType === "color") {
      const selectedColor = selectColors.find(
        (color) => color.name.toLowerCase() === value.toLowerCase(),
      );
      return selectedColor ? selectedColor.color : "unknown color";
    } else if (selectedType === "number") {
      const ball = balls.find((ball) => ball.number === value);
      return ball ? ball.color : "unknown color";
    } else if (selectedType === "big_small") {
      const bs = bigsmall.find(
        (item) => item.name.toLowerCase() === value.toLowerCase(),
      );
      return bs ? bs.color : "unknown color";
    }
    return "unknown color";
  };

  const handleAgreeChange = (event) => {
    setIsAgreed(event.target.checked);
  };

  const handleButtonClick = (color) => {
    setHeaderColor(color);
  };

  const [headerColor, setHeaderColor] = useState("");

  const toggleClassamtcolor = (buttonId, color, ballNumber) => {
    handleButtonClick(color);
  };

  const setColorInLocalStorage = (color) => {
    localStorage.setItem("color", color);
  };

  const setBallNumberInLocalStorage = (number) => {
    localStorage.setItem("number", number);
  };

  const handleColorButtonClick = (color) => {
    setColorInLocalStorage(color);
    Togglepopup();
    setSelectedName(color);
    handleButtonClick();
    toggleClassamtcolor(1, color);
    setLastButtonClicked("color");
  };

  const handleBallClick = (color, number) => {
    setBallNumberInLocalStorage(number);
    Togglepopup();
    setSelectedName(number);
    handleButtonClick();
    toggleClassamtcolor(1, color);
    setNumberColor(color);
    setLastButtonClicked("number");
  };

  const setBigsmallAndColorInLocalStorage = (name) => {
    localStorage.setItem("Bigsmall", name);
  };

  const handleBigsmallButtonClick = (name, color) => {
    setBigsmallAndColorInLocalStorage(name);
    setSelectedName(name);
    Togglepopup();
    handleButtonClick(name);
    toggleClassamtcolor(1, color);
    setLastButtonClicked("big_small");
  };

  const removeHtmlTags = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
  };

  const [losspopup, setLosspopup] = useState(false);
  const lossclose = () => setLosspopup(false);
  const LosscloseShow = () => setLosspopup(true);
  const [winpopup, setWinpopup] = useState(false);

  // Get current tab index based on saved selectedInterval
  const getCurrentTabIndex = () => {
    if (!userBetData || userBetData.length === 0) return 0;
    const sortedData = [...userBetData].sort(
      (a, b) => parseInt(a.intervalM) - parseInt(b.intervalM),
    );
    const index = sortedData.findIndex(
      (bet) => bet.intervalM === selectedInterval,
    );
    return index >= 0 ? index : 0;
  };

  return (
    <div className="game_App">
      <div id="color_game">
        <div className="top_new_header topheader p-2 bg-color-all d-flex justify-content-between align-items-center">
          <Link to="/" className="text-white text-2xl">
            <MdOutlineKeyboardArrowLeft />
          </Link>
          <h4 className="mb-0 text-white">
            <img src={logo} alt="logo" />
          </h4>
          <div className="d-flex gap-2">
            <Link to="/home" className="text_all_new_new text-white">
              <MdOutlineSupportAgent />
            </Link>
            <SiNeteasecloudmusic className="text_all_new_new text-white" />
          </div>
        </div>

        <div className="wingo_all_design">
          <WingoHeader message={messageToHeader} />
          <React.Fragment>
            <div className={`popup offcanvas_custum ${isopen ? "active" : ""}`}>
              <div onClick={Toggleoff} className="overlay_canvass"></div>
              <div className="popupbottomtotop">
                <div
                  className="bg_color_header"
                  style={{ background: headerColor }}
                >
                  <div className="titlegame">
                    <h3 className="text-white">
                      Win Go{" "}
                      {selectedInterval == "0.30"
                        ? `30 Sec`
                        : `${selectedInterval} Min`}
                    </h3>
                    <h4>
                      Select
                      <span> {selectedColor}</span>
                      <span> {selectedName}</span>
                      <span> {selectedNumber}</span>
                    </h4>
                  </div>
                </div>
                <div className="p-3 pb-0 d-flex flex-col gap-2">
                  <div className="d-flex justify-content-between align-items-center w-100">
                    <p className="mb-0 text-base">Balance</p>
                    <div className="d-flex justify-content-center align-items-center">
                      {[10, 100, 1000].map((value) => (
                        <button
                          key={value}
                          className={`button ${
                            activeBalanceButton === value ? "active_btn" : ""
                          } btn_amt`}
                          onClick={() => handleBalanceButtonClick(value)}
                        >
                          {value}
                        </button>
                      ))}
                    </div>
                  </div>
                  <div className="d-flex justify-content-between align-items-center w-100 mt-1">
                    <p className="mb-0 text-base">Quantity</p>
                    <div className="d-flex justify-content-center align-items-center">
                      <button className="counterbtnsd" onClick={decrement}>
                        -
                      </button>
                      <input className="inputcount" value={quantity} readOnly />
                      <button className="counterbtnsd" onClick={increment}>
                        +
                      </button>
                    </div>
                  </div>
                  <div className="d-flex justify-content-end align-items-center mt-1">
                    {[1, 5, 10, 20, 50, 100].map((mult) => (
                      <button
                        key={mult}
                        className={`button ${
                          activeMultiplierButton === mult ? "active_btn" : ""
                        } btn_amt`}
                        onClick={() => handleMultiplierButtonClick(mult)}
                      >
                        X{mult}
                      </button>
                    ))}
                  </div>
                  <div className="d-flex align-items-center justify-content-evenly mt-1"></div>
                  <div className="d-flex align-items-center py-2">
                    <div className="d-flex align-items-center">
                      <input
                        id="agreecheckbox"
                        type="checkbox"
                        name="r"
                        value="3"
                        className="mr-1"
                        onChange={handleAgreeChange}
                        checked={isAgreed}
                      />
                      <label htmlFor="03" className="text-danger text-sm">
                        I Agree
                      </label>
                    </div>
                    <button onClick={handleShowmodel}>
                      <h6 className="text-sm ml-2 text-danger mb-0">
                        {"<<"}Pre Rule{">>"}
                      </h6>
                    </button>
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  <div
                    className="closebtn text-base"
                    style={{ cursor: "pointer" }}
                    onClick={Togglepopup}
                  >
                    cancel
                  </div>
                  <div
                    className="totalamount text-base"
                    onClick={() => {
                      if (!clicked) {
                        handleSaveTotalAmount(totalAmount);
                        setClicked(true);
                      }
                    }}
                    disabled={clicked}
                    style={{
                      background: headerColor,
                      cursor: "pointer",
                    }}
                  >
                    Total Amount : {totalAmount}
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
          <section className="wingosection">
            <div className="wingo padding_all">
              <div className="allbefore position-relative">
                <Container>
                  <div className="windgo_tabs">
                    <Tabs
                      selectedIndex={getCurrentTabIndex()}
                      onSelect={(index) => {
                        if (userBetData) {
                          const sortedData = [...userBetData].sort(
                            (a, b) =>
                              parseInt(a.intervalM) - parseInt(b.intervalM),
                          );
                          const selectedBet = sortedData[index];
                          if (selectedBet) {
                            handleTabClick(
                              selectedBet.intervalM,
                              selectedBet.typeID,
                            );
                          }
                        }
                      }}
                    >
                      <TabList className="d-flex justify-content-between bg_color_tabs_new">
                        {userBetData &&
                          userBetData
                            .sort(
                              (a, b) =>
                                parseInt(a.intervalM) - parseInt(b.intervalM),
                            )
                            .map((bet, index) => (
                              <Tab key={index}>
                                <div className="tabs_windgo">
                                  <div className="d-flex justify-content-center align-items-center icon_rounded">
                                    <IoIosClock />
                                  </div>
                                  <p>
                                    Win Go{" "}
                                    <span>
                                      {" "}
                                      {bet.intervalM == "0.30"
                                        ? `30 Sec`
                                        : `${bet.intervalM} Min`}
                                    </span>
                                  </p>
                                </div>
                              </Tab>
                            ))}
                      </TabList>
                      {userBetData &&
                        userBetData
                          .sort(
                            (a, b) =>
                              parseInt(a.intervalM) - parseInt(b.intervalM),
                          )
                          .map((bet, index) => (
                            <TabPanel key={index}>
                              <div className="bg-color-all tab_active p-2 rounded border_offset">
                                <div className="d-flex justify-content-between align-items-center">
                                  <div className="Howtoplay">
                                    {selectedTypeID !== null && (
                                      <h5
                                        onClick={handleShow}
                                        className="mb-0 d-flex align-items-center justify-content-center gap-1"
                                      >
                                        <IoDocumentTextSharp />
                                        How To Play
                                      </h5>
                                    )}
                                    <Modal show={show} onHide={handleClose}>
                                      <Modal.Header
                                        className="bg-color-all"
                                        closeButton
                                      >
                                        <Modal.Title className="position-absolute text-light top-1.5 left-26 text-center text-base">
                                          How to play
                                        </Modal.Title>
                                      </Modal.Header>

                                      <Modal.Body className="modal-body-scroll">
                                        {loading ? (
                                          <p>Loading...</p>
                                        ) : (
                                          ruleData && (
                                            <div>
                                              {removeHtmlTags(
                                                ruleData.gamePresentation,
                                              )
                                                .split("\n")
                                                .map((line, index) => (
                                                  <p key={index}>{line}</p>
                                                ))}
                                            </div>
                                          )
                                        )}
                                      </Modal.Body>
                                      <Modal.Footer>
                                        <Button
                                          variant="secondary"
                                          onClick={handleClose}
                                        >
                                          Close
                                        </Button>
                                      </Modal.Footer>
                                    </Modal>
                                    {selectedInterval !== null && (
                                      <p className="textcolor">
                                        Win Go{" "}
                                        {selectedInterval == "0.30"
                                          ? `30 Sec`
                                          : `${selectedInterval} Min`}
                                      </p>
                                    )}

                                    <div className="d-flex justify-content-between gap-1 mt-1">
                                      <div className="w-6 h-6">
                                        <img src={One} alt="One" />
                                      </div>
                                      <div className="w-6 h-6">
                                        <img src={Two} alt="Two" />
                                      </div>
                                      <div className="w-6 h-6">
                                        <img src={Three} alt="Three" />
                                      </div>
                                      <div className="w-6 h-6">
                                        <img src={Four} alt="Four" />
                                      </div>
                                      <div className="w-6 h-6">
                                        <img src={Five} alt="Five" />
                                      </div>
                                    </div>
                                  </div>
                                  {showPopup && (
                                    <div className="popup d-flex justify-content-between countdown_time"></div>
                                  )}
                                  <div className="Countdown_timer">
                                    <h5 className="textcolor text-sm">
                                      Time Remaining
                                    </h5>
                                    <div className="d-flex justify-content-between countdown_time">
                                      {formatTime(remainingSec)
                                        .split("")
                                        .map((char, index) => (
                                          <div
                                            className="countdown"
                                            key={index}
                                          >
                                            <span
                                              key={index}
                                              className="time-digit"
                                            >
                                              {char}
                                            </span>
                                          </div>
                                        ))}
                                    </div>
                                    <h5 className="textcolor text-sm mt-1">
                                      {periodId}
                                    </h5>
                                  </div>
                                </div>
                                <div className="line"></div>
                              </div>
                            </TabPanel>
                          ))}
                    </Tabs>
                  </div>

                  <div className="game_board">
                    <Card>
                      <Card.Body className="card_color">
                        <div className="d-flex align-items-center justify-content-between">
                          {selectColors.map((item, index) => (
                            <button
                              key={index}
                              className="button_color_game"
                              onClick={() =>
                                handleColorButtonClick(item.name, item.color)
                              }
                            >
                              {item.name}
                            </button>
                          ))}
                        </div>
                        <div className="ballbgcolor rounded p-2 mt-1">
                          {showFiveSecondsLeft && (
                            <div className="remainingtime">
                              <h3 className="timer">
                                <div className="minutes">
                                  {parseInt(
                                    formatTime(popupRemainingSec).split(":")[0],
                                    10,
                                  )}
                                </div>
                                <div className="seconds">
                                  {parseInt(
                                    formatTime(popupRemainingSec).split(":")[1],
                                    10,
                                  )}
                                </div>
                              </h3>
                            </div>
                          )}
                          <div className="d-flex justify-content-between flex-wrap gap-2 mt-1">
                            {balls.slice(0, 5).map((ball) => (
                              <div key={ball.number} className="ball_number">
                                <img
                                  onClick={() =>
                                    handleBallClick(ball.color, ball.number)
                                  }
                                  src={ball.image}
                                  alt={`Ball ${ball.number}`}
                                />
                              </div>
                            ))}
                          </div>
                          <div className="d-flex justify-content-between flex-wrap gap-2 mt-1 mb-2">
                            {balls.slice(5, 10).map((ball) => (
                              <div key={ball.number} className="ball_number">
                                <img
                                  onClick={() =>
                                    handleBallClick(ball.color, ball.number)
                                  }
                                  src={ball.image}
                                  alt={`Ball ${ball.number}`}
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-between mt-2 mb-1 overflow-scroll">
                          <button className="border text-danger multiple_winredom">
                            Random
                          </button>
                          {betMultipleValues.length > 0 &&
                            betMultipleValues.map((bet, index) => (
                              <button
                                key={index}
                                className={`button ${
                                  activeBalanceButton === bet
                                    ? "bg-warning text-light"
                                    : ""
                                } multiple_win`}
                                onClick={() => handleBalanceButtonClick(bet)}
                              >
                                X{bet}
                              </button>
                            ))}
                        </div>
                        {/* <div className="d-flex align-items-center justify-content-evenly mt-1">
                          {bigsmall.map((item, index) => (
                            <button
                              key={index}
                              variant="primary"
                              onClick={() =>
                                handleBigsmallButtonClick(item.name, item.color)
                              }
                              className="button_color_big_small"
                              style={{ backgroundColor: item.color }}
                            >
                              {item.name}
                            </button>
                          ))}
                        </div> */}
                      </Card.Body>
                    </Card>
                  </div>
                </Container>
              </div>

              <Modal
                scrollable={true}
                show={showmodel}
                onHide={handlemodelclose}
              >
                <Modal.Header closeButton className="bg-image-header-rule">
                  <Modal.Title className="position-absolute text-dark top-1.5 left-24 text-center text-base">
                    《Pre-sale rules》
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <p className="pb-0 mb-0 text-sm leading-2 ">
                    "In order to protect the legitimate rights and interests of
                    users participating in the pre-sale and maintain the normal
                    operating order of the pre-sale, these rules are formulated
                    in accordance with relevant agreements and laws and
                    regulations. country Chapter 1 Definition1.1 Pre-sale
                    definition: refers to a sales model in which a seller offers
                    a bundle of a product or service, collects consumer orders
                    through product tools before selling, and makes it available
                    to customers. consumers of goods and/or services by prior
                    agreement1.2 Presale mode is "deposit" mode. "Consignment"
                    refers to the pre-delivery of a fixed number of items prior
                    to sale. "Deposit" Scam Join mini games for a chance to win
                    more deposits. Deposits can be exchanged directly for goods.
                    Deposit is not refundable.1.3 Pre-sale product: A product
                    that is shipped by the seller using the pre-sale product
                    tool. Only highlight the word presale on the product name or
                    product detail page, and products that do not use the
                    presale product tool are not presale. 1.4 Pre-sale system:
                    refers to the system product tool that helps sellers to sell
                    samples before selling.1.5 Product price before selling: is
                    the selling price of the product before selling. The price
                    of pre-sale items consists of two parts: deposit and final
                    payment. "
                  </p>
                </Modal.Body>
                <Modal.Footer className="justify-content-center inkow_footer">
                  <button
                    className="iknow w-60 rounded-xl leading-8 text-center text-base text-white"
                    onClick={handlemodelclose}
                  >
                    I know
                  </button>
                </Modal.Footer>
              </Modal>
            </div>

            <div>
              {winpopup && showWin && (
                <div className="model_custum">
                  <div className="winimage">
                    <div className="content_win">
                      <div className="result_name d-flex justify-content-between align-items-center">
                        <p
                          className="mb-0 color_box"
                          style={{ backgroundColor: newcolor, color: "#fff" }}
                        >
                          {resultsData && resultsData[0]?.color}
                        </p>

                        <p
                          className="mb-0 number_round"
                          style={{ backgroundColor: newcolor, color: "#fff" }}
                        >
                          {resultsData?.[0]?.number}
                        </p>

                        <p
                          className="mb-0 color_box"
                          style={{ backgroundColor: newcolor, color: "#fff" }}
                        >
                          Win
                        </p>
                      </div>
                      <div className="game_allnew">
                        <h3 className="d-flex justify-content-center align-items-center fw-bold text-green">
                          <FaIndianRupeeSign />
                          {winAmount?.toFixed(2) || 0}
                        </h3>
                        <h6 className="winingamountperied">
                          Peried Win:{" "}
                          {resultsData && resultsData[0]?.game_type_time}{" "}
                          Minutes{" "}
                          <span>
                            {" "}
                            {resultsData && resultsData[0]?.periodid}
                          </span>
                        </h6>
                      </div>
                      <span
                        onClick={() => {
                          setWinpopup(false);
                          setShowWin(false);
                        }}
                        className="close_times"
                      >
                        &times;
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div>
              {losspopup && showLoss && (
                <div className="model_custum">
                  <div className="lossimage">
                    <div className="content_loss">
                      <h3 className="Sorrytext">Sorry</h3>
                      <div className="result_name d-flex justify-content-between align-items-center ">
                        <p className="mb-0 pb-0 result-name">Result Name</p>
                        <p className="mb-0 pb-0 result-color">
                          {resultsData && resultsData[0]?.color}
                        </p>
                        <p className="mb-0 pb-0 result-time">
                          {resultsData && resultsData[0]?.number}
                        </p>
                        <p className="mb-0 pb-0 result-type">
                          {resultsData && resultsData[0]?.big_small}
                        </p>
                      </div>
                      <div className="d-flex justify-content-center flex-col betwinlose">
                        <div className="loss_amount d-flex justify-content-center align-items-center mt-2 text-dark fw-bold">
                          <FaIndianRupeeSign /> {lossAmount?.toFixed(2) || 0}
                        </div>
                        <h6 className="period-css text-secondary">
                          Period {resultsData && resultsData[0]?.game_type_time}{" "}
                          Minutes {resultsData && resultsData[0]?.periodid}
                        </h6>
                        <h3 className="Loss">Lose</h3>
                      </div>
                      <span
                        onClick={() => {
                          setLosspopup(false);
                          setShowLoss(false);
                        }}
                        className="close_times"
                      >
                        &times;
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </section>
          <WingoChart
            results={results}
            setResults={setResults}
            colorList={colorList}
            setColorList={setColorList}
          />
        </div>
      </div>
    </div>
  );
}
